import { ButtonColors, PartialEmotionCanvasTheme, colors } from '@workday/canvas-kit-react'
import { ppcolors } from './colors'

export const SecondaryButtonColorsWithWhiteBackground: ButtonColors = {
  default: {
    background: colors.frenchVanilla100,
    border: colors.blackPepper400,
    icon: colors.blackPepper400,
    label: colors.blackPepper400
  },
  hover: {
    background: colors.blackPepper400,
    border: colors.blackPepper400,
    icon: colors.frenchVanilla100,
    label: colors.frenchVanilla100
  },
  active: {
    background: colors.blackPepper500,
    border: colors.blackPepper500,
    icon: colors.frenchVanilla100,
    label: colors.frenchVanilla100
  },
  focus: {
    border: colors.blackPepper400,
    icon: colors.blackPepper400,
    label: colors.blackPepper400
  },
  // Identical to 'default' styles. ButtonContainer will set opacity to 40%
  disabled: {
    background: colors.frenchVanilla100,
    border: colors.blackPepper400,
    icon: colors.blackPepper400,
    label: colors.blackPepper400
  }
}

export const PrimaryButtonColors: ButtonColors = {
  default: { background: ppcolors.AppRed, icon: colors.frenchVanilla100, label: colors.frenchVanilla100 },
  hover: { background: ppcolors.AppRedDarker },
  active: { background: ppcolors.AppRedDarkest },
  focus: {},
  disabled: {}
}

export const PrimaryAEDButtonColors: ButtonColors = {
  default: { background: colors.sourLemon400, icon: colors.blackPepper500, label: colors.blackPepper500 },
  hover: { background: colors.sourLemon500 },
  active: { background: '#971115' },
  focus: {},
  disabled: {}
}

export const MenuTheme: PartialEmotionCanvasTheme = {
  canvas: {
    palette: {
      primary: {
        lightest: colors.soap300,
        main: ppcolors.AppRed,
        contrast: colors.frenchVanilla100
      }
    }
  }
}

export const PulsePointAEDTheme: PartialEmotionCanvasTheme = {
  canvas: {
    palette: {
      primary: {
        lightest: colors.sourLemon200,
        light: colors.sourLemon300,
        main: colors.sourLemon400,
        dark: colors.sourLemon500,
        darkest: colors.sourLemon600,
        contrast: colors.blackPepper500
      }
    }
  }
}

export const ComponentTheme: PartialEmotionCanvasTheme = {
  canvas: {
    palette: {
      primary: {
        main: ppcolors.AppRed
      }
    }
  }
}
